import React from 'react';
import styled from 'styled-components';

const FooterSection = styled.footer`
  padding: 3rem 0;
  background-color: ${props => props.theme.colors.primary.background};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FooterLogo = styled.div`
  font-family: ${props => props.theme.fonts.heading};
  font-weight: 700;
  font-size: 1.5rem;
  color: ${props => props.theme.colors.text.primary};
  margin-bottom: 1.5rem;
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 2rem;
  margin-bottom: 2rem;
  
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
`;

const FooterLink = styled.a`
  color: ${props => props.theme.colors.text.secondary};
  transition: color 0.3s ease;
  
  &:hover {
    color: ${props => props.theme.colors.accent.teal};
  }
`;

const FooterSocial = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
`;

const SocialLink = styled.a`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.text.primary};
  font-size: 1.2rem;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${props => props.theme.colors.accent.teal};
    transform: translateY(-3px);
  }
`;

const Copyright = styled.p`
  color: ${props => props.theme.colors.text.secondary};
  font-size: 0.9rem;
  text-align: center;
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterSection>
      <FooterContainer>
        <FooterLogo>Nicholas Bentley</FooterLogo>
        <FooterLinks>
          <FooterLink href="#home">Home</FooterLink>
          <FooterLink href="#about">About</FooterLink>
          <FooterLink href="#experience">Experience</FooterLink>
          <FooterLink href="#skills">Skills</FooterLink>
          <FooterLink href="#education">Education</FooterLink>
          <FooterLink href="#contact">Contact</FooterLink>
        </FooterLinks>
        <FooterSocial>
          <SocialLink href="https://www.linkedin.com/in/nick-bentley/" target="_blank" rel="noopener noreferrer">
            in
          </SocialLink>
          <SocialLink href="#" target="_blank" rel="noopener noreferrer">
            🐦
          </SocialLink>
          <SocialLink href="#" target="_blank" rel="noopener noreferrer">
            📷
          </SocialLink>
        </FooterSocial>
        <Copyright>
          &copy; {currentYear} Nicholas Bentley. All rights reserved.
        </Copyright>
      </FooterContainer>
    </FooterSection>
  );
};

export default Footer;
